import { ReviewReactionWidget } from '@place/ui'
import { config } from '@react-spring/web'

import { useReaction } from '@web/components/ReactionArea/useReaction'
import { gql } from '@web/gql'
import { ReactionArea_ReviewGroupFragment } from '@web/gql/graphql'
import { reactionTypeMap } from '@web/types/reaction-type'

import { ReactionNClickArea } from './reaction.constant'
import styles from './ReactionArea.module.scss'
import Tooltip from '../Tooltip/Tooltip'
import { ReactionLayer } from './ReactionLayer/ReactionLayer'

interface Props {
  reviewGroup: ReactionArea_ReviewGroupFragment
  nClickArea: ReactionNClickArea
  checkOverViewport?: boolean
  onlyPopOver?: boolean
}

export const ReactionArea = ({ reviewGroup, nClickArea, checkOverViewport = true }: Props) => {
  const {
    me,
    isLayerOutOfViewport,
    openReactionModal,
    ref: reactionTooltipRef,
    toggleReactionLayer,
    showReactionTooltip,
    showReactionLayer,
    closeReactionLayer,
    openLayerButtonRef,
    hasReaction,
    layerRef,
  } = useReaction({ reviewGroup, checkOverViewport })

  return (
    <>
      {showReactionTooltip && (
        <div className={styles.ly_tooltip_wrapper} ref={reactionTooltipRef}>
          <Tooltip
            pinPosition="top"
            pinStyle={{ left: 16 }}
            transition={{
              config: config.wobbly,
              from: { opacity: 0, transform: 'translateY(-15px)' },
              enter: { opacity: 1, transform: 'translateY(0)' },
              leave: { opacity: 0, transform: 'translateY(-15px)' },
            }}
          >
            표정을 눌러 <em>반응을 남겨 보세요!</em>
          </Tooltip>
        </div>
      )}
      <ReviewReactionWidget
        {...{
          reactClickCode: hasReaction ? nClickArea.REACT : nClickArea.REACT_FIRST,
          reactionListClickCode: nClickArea.REACT_LIST,
          hasMyReaction: !!reviewGroup.myReactionType,
          reactionCounts:
            reviewGroup.reactionStat?.reactionCounts.map(reactionCount => ({
              count: reactionCount.count,
              reaction: {
                emojiUrl: reactionTypeMap.get(reactionCount.reactionType)?.emojiUrl ?? '',
                name: reactionTypeMap.get(reactionCount.reactionType)?.name ?? '',
              },
            })) ?? [],
          mainNickname: me?.profile.nickname ?? '플레이스리뷰어',
          onReactionClick: toggleReactionLayer,
          onReactionCountClick: e =>
            openReactionModal(e, {
              reviewGroupId: reviewGroup.id,
              reactionStat: reviewGroup.reactionStat,
              nClickArea,
            }),
          ref: openLayerButtonRef as any,
        }}
      />
      {showReactionLayer && (
        <ReactionLayer
          reviewGroup={reviewGroup}
          closeReactionLayer={closeReactionLayer}
          nClickArea={nClickArea}
          showOnTop={isLayerOutOfViewport()}
          layerRef={layerRef}
        />
      )}
    </>
  )
}

ReactionArea.fragments = {
  reviewGroup: gql(`
    fragment ReactionArea_ReviewGroup on ReviewGroup {
      ...ReactionLayer_ReviewGroup
      id
      myReactionType
      reactionStat {
        id
        totalCount
        ...reactionModal_reactionStat
      }
    }
  `),
}
